import { features } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h3 className="text-xs tracking-widest uppercase text-primary-500 font-medium mb-2">Why Choose Us</h3>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">平台特色</h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">五大核心优势，定义最佳观影体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {features.map((feature) => (
            <div key={feature.id} className="text-center bg-background-100 rounded-lg p-6 border border-secondary-200/60">
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                <i className={`${feature.icon} text-2xl`}></i>
              </div>
              <h3 className="text-sm font-heading font-bold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}